import React from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { TaskSubtaskNameWithRequirement } from "./TaskSubtaskRequirementBadge";
import { locallyDone } from "../tasks_hub/taskHubUtils";

// The same hierarchy for audit and regular responses. Instructions are never
// answers: instructions, saved notes and attachments all stay visible.
export default function TaskResponseSummary({
  subtask,
  status,
  onEdit,
  isAssignedToEveryone,
  plan_task_assignment_members,
  showAttribution,
  completion = locallyDone(subtask),
}) {
  const sub = subtask.plan_subtask || {};
  const answerText = subtask.value_text == null ? "" : String(subtask.value_text);
  const hasAnswerText = answerText.trim().length > 0;
  const showStatus = !sub.is_optional || completion || sub.type === "checkbox" ||
    (sub.type === "pass_fail" && typeof subtask.value_boolean === "boolean");
  const member = subtask.store_team_member;
  const who = member && (member.full_name || `${member.first_name || ""} ${member.last_name || ""}`.trim());
  const attributionVisible = showAttribution ?? (
    (isAssignedToEveryone || plan_task_assignment_members?.length > 1) && member && subtask.is_completed
  );
  return (
    <div className="min-w-0 flex-1">
      <p className="text-sm leading-5 font-medium text-slate-900 break-words">
        <TaskSubtaskNameWithRequirement name={sub.name} isOptional={sub.is_optional} type={sub.type} />
      </p>
      {sub.description ? (
        <p className="text-xs text-slate-500 mt-0.5 whitespace-pre-wrap break-words">{sub.description}</p>
      ) : null}
      <div className="flex items-center gap-x-3 gap-y-1 mt-3 sm:flex-col sm:items-start">
        {showStatus && (
          <div className="shrink-0">
            {status || <span className="text-xs font-medium text-slate-500">{completion ? "Completed" : sub.type === "text" ? "Not answered" : "Not completed"}</span>}
          </div>
        )}
        <div className="flex min-w-0 max-w-full items-center gap-2">
          {attributionVisible && (who || subtask.completed_at_formatted) ? (
            <p className="min-w-0 text-xs text-slate-500 break-words">{[who, subtask.completed_at_formatted].filter(Boolean).join(" · ")}</p>
          ) : null}
          {onEdit && (
            <button
              type="button"
              onClick={onEdit}
              aria-label={`Edit response for ${sub.name}`}
              className="inline-flex shrink-0 min-h-[44px] min-w-[44px] items-center justify-center gap-1 rounded text-xs text-slate-500 hover:text-violet-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600"
            >
              <EditOutlinedIcon aria-hidden="true" style={{ fontSize: 14 }} />
              Edit
            </button>
          )}
        </div>
      </div>
      {hasAnswerText ? (
        <div className="mt-3 border-l-2 border-violet-200 pl-3" role="group" aria-label="Saved response">
          <p className="text-sm text-slate-700 whitespace-pre-wrap break-words">{answerText}</p>
        </div>
      ) : null}
    </div>
  );
}
